<div
  *ngIf="job$ | async as job"
  class="compact-job-list-item">
  <div
    *ngFor="let column of columns; trackBy: trackByColumnKey"
    class="compact-job-list-item-column"
    [attr.data-column-key]="column.key"
    [class.with-text-m]="
      column.key === 'organisation' || column.key === 'address'
    "
    [class.with-text-ellipsis]="
      column.key !== 'shift' && column.key !== 'status'
    "
    [class.with-small-spacing]="column.smallSpacing"
    [class.with-fade-right]="
      column.key === 'shift' ||
      column.key === 'status' ||
      column.key === 'transfers'
    ">
    <ng-container *ngIf="column.key === 'status'">
      <app-job-list-item-counts
        [hidePotentialInviteeCount]="job.status !== JobStatusEnum.OPEN"
        [counts]="(counts$ | async) ?? undefined"></app-job-list-item-counts
    ></ng-container>
    <ng-container *ngIf="column.key === 'shift'">
      <app-job-list-item-date-time [job]="job"></app-job-list-item-date-time>
    </ng-container>
    <ng-container *ngIf="column.key === 'department'">
      <app-job-list-item-organisation-heading
        [jobType]="job.multiDayId ? 'job-series' : 'job'"
        [department]="job.department"
        [organisation]="job.organisation"
        [departmentOnly]="true"
        [compact]="true"></app-job-list-item-organisation-heading>
    </ng-container>
    <ng-container *ngIf="column.key === 'organisation'">
      <span [attr.title]="job.organisation?.name">
        {{ job.organisation?.name }}
      </span>
    </ng-container>
    <ng-container *ngIf="column.key === 'address'">
      <span
        title="{{
          job.organisation.address?.street +
            ', ' +
            job.organisation.address?.zip +
            ' ' +
            job.organisation.address?.location
        }}">
        {{
          job.organisation.address?.street
            ? job.organisation.address?.street + ", "
            : ""
        }}
        {{
          job.organisation.address?.zip
            ? job.organisation.address?.zip + " "
            : ""
        }}
        {{
          job.organisation.address?.location
            ? job.organisation.address?.location
            : ""
        }}
      </span>
      <span [attr.title]="job.department.phone || ''">
        {{
          !job.department.phone
            ? ""
            : job.organisation.address
            ? " | " + job.department.phone
            : job.department.phone
        }}
      </span>
    </ng-container>
    <ng-container *ngIf="column.key === 'bookedInvitees'">
      <ng-container
        *ngIf="compactOverviewInvitee$ | async as compactOverviewInvitee">
        <app-job-list-item-compact-invitees
          [invitee]="compactOverviewInvitee"
          [customer]="(loggedInCustomer$ | async) || undefined"
          [extraInviteeCount]="
            (extraInviteeCount$ | async) || 0
          "></app-job-list-item-compact-invitees>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="column.key === 'transfers'">
      <ng-container *ngIf="transferCounts$ | async as transferCounts">
        <app-job-list-item-transfers
          [transferCounts]="transferCounts"
          [job]="job"></app-job-list-item-transfers>
      </ng-container>
      <ng-container *ngIf="transferredToMeText$ | async as transferredToMeText">
        <div
          class="transfer-info"
          [attr.title]="transferredToMeText">
          {{ transferredToMeText }}
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="column.key === 'jobType'">
      <span [attr.title]="('jobTypeEnum.' + (job?.jobType || '') | i18n) || ''">
        {{ ("jobTypeEnum." + (job?.jobType || "") | i18n) || "" }}
      </span>
    </ng-container>
    <ng-container *ngIf="column.key === 'caseNumberShort'">
      <span [attr.title]="job.caseNumber">
        {{ job.caseNumber }}
      </span>
    </ng-container>
    <ng-container *ngIf="column.key === 'description'">
      <span [attr.title]="job.description">
        {{ job.description }}
      </span>
    </ng-container>
    <ng-container *ngIf="column.key === 'demandReason'">
      <span
        [attr.title]="job.customerInternalInformation?.[(loggedInCustomer$ | async)?._id || '']?.demandReason?.displayName">
        {{ job.customerInternalInformation?.[(loggedInCustomer$ | async)?._id || '']?.demandReason?.displayName }}
      </span>
    </ng-container>
    <ng-container *ngIf="column.key === 'internalNote'">
      <span
        [attr.title]="job.customerInternalInformation?.[(loggedInCustomer$ | async)?._id || '']?.description">
        {{ job.customerInternalInformation?.[(loggedInCustomer$ | async)?._id || '']?.description }}
      </span>
    </ng-container>
    <ng-container *ngIf="column.key === 'certificate'">
      <span [attr.title]="jobCertificates$ | async">
        {{ jobCertificates$ | async }}
      </span>
    </ng-container>
    <ng-container *ngIf="column.key === 'createdAt'">
      <span [attr.title]="job.createdAt | date: 'dd.MM.yyyy HH:mm'">
        {{ job.createdAt * 1000 | date: "dd.MM.yyyy HH:mm" }}
      </span>
    </ng-container>
    <ng-container *ngIf="column.key === 'createdBy'">
      <span
        [attr.title]="job.createdBy?.firstName + ' ' + job.createdBy?.lastName">
        {{ job.createdBy?.firstName + " " + job.createdBy?.lastName }}
      </span>
    </ng-container>

    <ng-container *ngIf="column.key === 'updatedAt'">
      <span [attr.title]="job.updatedAt | date: 'dd.MM.yyyy HH:mm'">
        {{ job.updatedAt * 1000 | date: "dd.MM.yyyy HH:mm" }}
      </span>
    </ng-container>
  </div>
</div>
